import type { FC } from "react";

export type MaxType = "all-roads" | "selectedRoads";

interface SelectMaxButtonsProps {
  maxType: MaxType;
  onSelect: (maxType: MaxType) => void;
}

const SelectMaxButtons: FC<SelectMaxButtonsProps> = ({ maxType, onSelect }) => {
  return (
    <div className="d-flex gap-2 justify-content-center my-2">
      <button
        type="button"
        className={`btn btn-sm ${maxType === "all-roads" ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => onSelect("all-roads")}
      >
        All roads
      </button>
      <button
        type="button"
        className={`btn btn-sm ${maxType === "selectedRoads" ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => onSelect("selectedRoads")}
      >
        Selected road
      </button>
    </div>
  );
};

export default SelectMaxButtons;
